import React, {PureComponent} from 'react';

export default class AlertPoint extends PureComponent {
    render() : React.ReactNode {
        return <span className="updates"/>;
    }
}
